import React, {useLayoutEffect, useReducer} from "react";
import TableSortable from "../../components/TableSortable";
import moment from "moment";
import PendencyObj from "../../models/pendency";
import FilterPendencyObj from "../../contexts/filterPendency";
import {Typography, withStyles, withTheme} from "@material-ui/core";
import {withFb} from "../../contexts/FbProvider";
import {withDialog} from "../../contexts/DialogContext";
import FilterPendency from "../../forms/FilterPendency";
import localforage from "../../utils/localforage";
import {withApontamento} from "../../contexts/ApontamentoProvider";
import http from "../../utils/api";
import formatDate from "../../utils/formatDate";
import Pendency from "../../forms/Pendency";
import {AcoesApontamentoTable} from "./AcoesApontamentosTable";
import rows from "../../data/camposTabela";
import ApontamentoTopActions from './ApontamentosTopActions';
import reducer from '../../utils/defaultReducer';

const style = () => ({
    root: {},
});

const initialState = {
    openDialog: false,
    dataDialog: PendencyObj,
    selectedDate: moment(),
    saldoHoras: {horasPorDia: 8},
    horaDia: 0,
    objHoraDia: {},
    withPL: '',
    horasApontadas: 0,
    nomeLiderado: '',
};

function Apontamentos(props) {
    const [state, setState] = useReducer(reducer, initialState, () => initialState)
    useLayoutEffect(() => {
        (async () => {
            let periodo = await localforage.getItem('periodo');
            const ap = await localforage.getItem('apontamentos');
            if (!ap) {
                return http.get('apontamentos', {
                    params: {
                        dataHoraInicio: formatDate(periodo?.inicio),
                        dataHoraFim: formatDate()
                    }
                }).then(async ({data}) => {
                    await localforage.setItem('apontamentos', data.data);
                    props.apontamentos.setList(data.data)
                })
            }
            const arrayData = ap?.length ? ap : [];
            props.apontamentos.setList(arrayData);

            setState({
                saldoHoras: (await localforage.getItem('saldo-horas')) ?? {horasPorDia: 8}
            })
            handleSelectDate({dataHoraInicio: moment()})
        })()
    }, [])

    useLayoutEffect(() => {
        if (!props.apontamentos.list.some(item => moment(state.selectedDate).isSame(item.dataHoraInicio, 'day')) && props.apontamentos.list.length) {
            setState({
                selectedDate: moment(props.apontamentos.list[0].dataHoraInicio)
            })
        }
        localforage.getItem('liderado').then(ld => {
            if(ld){
                setState({
                    nomeLiderado: ld.nomeLiderado
                });
            }
        });
    }, [props.apontamentos.list])


    function filter() {
        localforage.getItem('filter-apontamento').then(docs => {
            const data = docs || FilterPendencyObj;
            props.dialog.open({
                close: () => {
                },
                minHeight: 260,
                noActionButtons: true,
                title: 'Filtrar Apontamento',
                content: <FilterPendency data={data} onCancel={props.dialog.close}
                                         onSubmit={props.apontamentos.filter} disableCloseOnSubmit={true}/>,
                size: 'sm'
            });
        });
    }

    function clickRow(data) {
        setState({
            dataDialog: data
        });

        props.dialog.open({
            noActionButtons: true,
            actions: null,
            title: `Editar Apontamento ${state.nomeLiderado}`,
            content: <Pendency
                data={data}
                onCancel={props.dialog.close}
                disableCloseOnSubmit={true}
                dateTime
                onSubmit={props.apontamentos.editSubmit}/>,
            size: 'md',
        })
    }

    function handleSelectDate(item) {
        setState({selectedDate: moment(item.dataHoraInicio)});
    }

    const onAcceptDelete = (pendency) => {
        props.dialog?.submiting?.();
        props.apontamentos.remove(pendency);
    }

    function deletePendency(pendency) {
        props.dialog.open({
            actions: null,
            title: 'Excluir',
            noFullWidth: false,
            onAccept: () => onAcceptDelete(pendency),
            content: <>
                <Typography>
                    Você deseja excluir o apontamento seguinte:
                </Typography>
                <Typography>
                    Data: {moment(pendency.dataHoraInicio).format('DD/MM/YYYY [às] HH:mm')}
                </Typography>
                {
                    pendency.atividadeAlocada && <Typography>
                        Atividade: {pendency.atividadeAlocada}
                    </Typography>
                }
            </>,
            size: 'xs',
        });
    }

    const acoesApontamentos = {
        title: 'Ações',
        component: (state, propsA, id, item) => <AcoesApontamentoTable state={state} props={propsA} id={id} item={item}
                                                                      dataProvider={props.data}/>
    };


    return <TableSortable
        {...props}
        rows={rows({})}
        orderBy="dataHoraInicio"
        order="desc"
        firstColumn={{...acoesApontamentos}}
        funcs={{
            clickRow,
            deletePendency,
        }}
        onClickRow={handleSelectDate}
        data={props.apontamentos.list}
        tableTitle={'Apontamentos  ' + (state.nomeLiderado ?  state.nomeLiderado: '')}
        topActions={<ApontamentoTopActions
            addPendencyDialog={() => props.apontamentos.addPendencyDialog({isNew: true, nomeLiderado: state.nomeLiderado})}
            filter={filter}
            horasPorDia={state.saldoHoras?.horasPorDia}
            dateTime={state.selectedDate}/>}
        idList={(item) => moment(item.dataHoraInicio).format('YYYY-MM-DD HH:mm')}
    />;
}


export default withFb(withDialog(withApontamento(withTheme(withStyles(style)(Apontamentos)))));
